<template>
  <div class="page" :style="{height:fixedHeight+'px'}" style="position: relative;overflow-y: auto;">
    <!-- 头部 -->
    <div class="titleView">
      <el-row>
        <el-col :span="4">采购申请日期: {{currentDate}}</el-col>
        <el-col :span="4">提交人: {{userInfo.uName}}</el-col>
        <el-col :span="4">商品数量: {{allCount}}</el-col>
        <el-col :span="8">采购数量: {{shopCount+drugCount}}</el-col>
        <el-col :span="4">
          <el-button type="warning" @click="handleBackClick" size="small">返回</el-button>
        </el-col>
      </el-row>
    </div>
    <!-- 商品类 -->
    <div class="shopClass" v-if="shops.length > 0">
      <div class="comH2" @click="handleShopClick">
        <div>商品类</div>
        <i class="el-icon-caret-bottom" v-if="showShop"></i>
        <i class="el-icon-caret-top" v-else></i>
      </div>
      <div class="tableWarp" v-if="showShop">
        <el-table ref="multipleTable1" :data="shops" tooltip-effect="dark" size="small">
          <el-table-column :key="1" prop="goods.title" label="商品名称" />
          <el-table-column :key="11">
            <template slot-scope="scope">
              <el-tag effect="dark" v-if="scope.row.procure_goods_state == 2" size="small" type="success">新</el-tag>
              <el-tag effect="dark" v-if="scope.row.procure_goods_state == 4" size="small">换</el-tag>
            </template>
          </el-table-column>
          <el-table-column :key="2" prop="goods.brand" label="品牌" align="center" />
          <el-table-column :key="3" prop="goods.skuValue" label="规格" align="center" width="120" />
          <el-table-column :key="5" prop="goods.unit" label="单位" align="center" />
          <el-table-column :key="4" prop="goodsCount" label="数量" align="center">
            <template slot-scope="scope">
              <el-input-number v-model="scope.row.goodsCount" controls-position="right" :min="0" :max="1000" style="width:100px" @change="handleCountChange(1,scope.row,scope.$index)" size="small" />
            </template>
          </el-table-column>
          <el-table-column :key="9" prop="procureGoodsRemark" label="备注" align="center">
            <template slot-scope="scope">
              <el-input type="textarea" placeholder="请输入内容" v-model="scope.row.procureGoodsRemark" maxlength="30" resize="none" @input="handleRemarkChange(1,scope.$index,scope)" clearable
                size="small" />
            </template>
          </el-table-column>
          <el-table-column :key="10" fixed="right" label="操作" align="center" width="160">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="handleDeleteClick(1,scope.row,scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="allNum">
          <div>共{{shopCount}}件</div>
        </div>
      </div>
    </div>
    <!-- 医疗类 -->
    <div class="shopClass" v-if="drugs.length > 0">
      <div class="comH2" @click="handleDrugClick">
        <div>医疗类</div>
        <i class="el-icon-caret-bottom" v-if="showDrug"></i>
        <i class="el-icon-caret-top" v-else></i>
      </div>
      <div class="tableWarp" v-if="showDrug">
        <el-table ref="multipleTable2" :data="drugs" tooltip-effect="dark" style="overflow:initial">
          <el-table-column :key="1" prop="goods.title" label="商品名称" />
          <el-table-column :key="11">
            <template slot-scope="scope">
              <el-tag effect="dark" v-if="scope.row.procure_goods_state == 2" size="small" type="success">新</el-tag>
              <el-tag effect="dark" v-if="scope.row.procure_goods_state == 4" size="small">换</el-tag>
            </template>
          </el-table-column>
          <el-table-column :key="2" prop="goods.brand" label="品牌" align="center" />
          <el-table-column :key="3" prop="goods.skuValue" label="规格" align="center" width="120" />
          <el-table-column :key="5" prop="goods.unit" label="单位" align="center" />
          <el-table-column :key="4" prop="goodsCount" label="数量" align="center">
            <template slot-scope="scope">
              <el-input-number v-model="scope.row.goodsCount" controls-position="right" :min="0" :max="1000" style="width:100px" @change="handleCountChange(2,scope.row,scope.$index)" size="small" />
            </template>
          </el-table-column>
          <el-table-column :key="9" prop="procureGoodsRemark" label="备注" align="center">
            <template slot-scope="scope">
              <el-input type="textarea" placeholder="请输入内容" v-model="scope.row.procureGoodsRemark" maxlength="30" resize="none" @input="handleRemarkChange(2,scope.$index,scope)" clearable
                size="small" />
            </template>
          </el-table-column>
          <el-table-column :key="10" fixed="right" label="操作" align="center" width="160">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="handleDeleteClick(2,scope.row,scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="allNum">
          <div>共{{drugCount}}件</div>
        </div>
      </div>
    </div>
    <!-- 耗材类 -->
    <div class="shopClass" v-if="haocais.length > 0">
      <div class="comH2" @click="handleHaocaiClick">
        <div>耗材类</div>
        <i class="el-icon-caret-bottom" v-if="showHaocai"></i>
        <i class="el-icon-caret-top" v-else></i>
      </div>
      <div class="tableWarp" v-if="showHaocai">
        <el-table ref="multipleTable2" :data="haocais" tooltip-effect="dark" style="overflow:initial">
          <el-table-column :key="1" prop="goods.title" label="商品名称" />
          <el-table-column :key="11">
            <template slot-scope="scope">
              <el-tag effect="dark" v-if="scope.row.procure_goods_state == 2" size="small" type="success">新</el-tag>
              <el-tag effect="dark" v-if="scope.row.procure_goods_state == 4" size="small">换</el-tag>
            </template>
          </el-table-column>
          <el-table-column :key="2" prop="goods.brand" label="品牌" align="center">
            <template>
              <span>--</span>
            </template>
          </el-table-column>
          <el-table-column :key="3" prop="goods.skuValue" label="规格" align="center" width="120">
            <template>
              <span>--</span>
            </template>
          </el-table-column>
          <el-table-column :key="5" prop="goods.unit" label="单位" align="center" />
          <el-table-column :key="4" prop="goodsCount" label="数量" align="center">
            <template slot-scope="scope">
              <el-input-number v-model="scope.row.goodsCount" controls-position="right" :min="0" :max="1000" style="width:100px" @change="handleCountChange(3,scope.row,scope.$index)" size="small" />
            </template>
          </el-table-column>
          <el-table-column :key="9" prop="procureGoodsRemark" label="备注" align="center">
            <template slot-scope="scope">
              <el-input type="textarea" placeholder="请输入内容" v-model="scope.row.procureGoodsRemark" maxlength="30" resize="none" @input="handleRemarkChange(3,scope.$index,scope)" clearable
                size="small" />
            </template>
          </el-table-column>
          <el-table-column :key="10" fixed="right" label="操作" align="center" width="160">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="handleDeleteClick(3,scope.row,scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="allNum">
          <div>共{{haocaiCount}}件</div>
        </div>
      </div>
    </div>
    <div class="remarks" v-if="shops.length !=0 || drugs.length != 0 || haocais != 0">
      <div class="labelRemark">备注</div>
      <el-input type="textarea" placeholder="请输入内容" v-model="textarea" maxlength="30" resize="none" style="width: 240px;height: 80px;" />
    </div>
    <!-- 底部按钮 -->
    <div style="height: 72px;"></div>
    <div class="fix_btn">
      <el-button type="warning" @click="handleAddgoodsClick" size="small">添加商品</el-button>
      <el-button type="warning" @click="handleSubmitClick" size="small">提交</el-button>
    </div>
    <!-- 添加商品弹框 -->
    <div v-if="dialogAddShop_state">
      <dialogAddShop @closeOn="dialogAddShop_state = false" :addShopState.sync="dialogAddShop_state" @submit="selectShop" :tree.sync="tree"></dialogAddShop>
    </div>
  </div>
</template>
<script>
import { addCaigou } from "@/api/purchaseApiNew.js";
import dialogAddShop from "../../../components/dialog_addShopCG.vue";
export default {
  components: {
    dialogAddShop,
  },
  data() {
    return {
      currentDate: "", //当前日期
      currentDateStr: "", //当前时间戳
      userInfo: this.$store.state.userInfo,
      dialogFormVisible: false,
      fixedHeight: "",
      textarea: "", //备注
      allCount: 0, //商品件数
      shops: [], //商品类
      drugs: [], //药品类
      haocais: [], //耗材类
      showShop: true, //显示商品类
      showDrug: true, //显示药品类
      showHaocai: true, //显示耗材类
      shopCount: 0,
      drugCount: 0,
      haocaiCount: 0,
      dialogAddShop_state: false, //商品弹框状态
      addGoodsType: false, //商品弹框状态   false是添加商品  true是更换
      tree: [
        {
          id: "602f1e89c904d9db7ccf3c03",
        },
        {
          id: "602f1e88c904d9db7ccf3bec",
        },
        {
          id: "6049cf035a0dfcc381f9311a",
        },
      ],
      routerMsg: this.$route.query.routerMsg, //跳转数据
    };
  },
  mounted() {
    this.fixedHeight = document.documentElement.clientHeight - 76;
    this.getDateData();
    if (this.routerMsg != undefined) {
      console.log("跳转数据", this.routerMsg.procure_goods_list);
      let list = this.routerMsg.procure_goods_list;
      let procure_goods = null;
      list.map((item) => {
        console.log(item,"itemmmmmmm");
        if (item.goods.goodsType == "1") {
          //药品
          procure_goods = {
            goods: {
              goodsId: item.goods.goodsId,
              title: item.goods.title,
              skuId: "",
              skuValue: item.goods.skuValue,
              goodsType: 1,
              brand: item.goods.brand,
              times: item.goods.times,
              unitId: item.goods.unitId,
              unit: item.goods.unit,
            },
            goodsCount: 1,
            procureGoodsRemark: "",
          };
          this.drugs.push(procure_goods);
          this.getAllData();
          console.log("添加药品列表", this.drugs);
          this.allCount =
            this.drugs.length + this.shops.length + this.haocais.length;
        } else {
          procure_goods = {
            goods: {
              goodsId: item.goods.goodsId,
              title: item.goods.title,
              category_id: item.goods.category_id,
              category_name: item.goods.category_name,
              skuId: item.goods.skuId,
              skuValue: item.goods.skuValue,
              goodsType: 0,
              brand: item.goods.brand,
              times: 1,
              unitId: item.goods.unitId,
							unit:item.goods.unit,
            },
            goodsCount: 1,
            procureGoodsRemark: "",
          };
          this.shops.push(procure_goods);
          this.getAllData();
          console.log("添加商品列表", this.shops);
          this.allCount =
            this.drugs.length + this.shops.length + this.haocais.length;
        }
      });
    }
  },
  methods: {
    //提交
    handleSubmitClick() {
      if (
        this.shops.length == 0 &&
        this.drugs.length == 0 &&
        this.haocais.length == 0
      ) {
        this.$message({
          message: "请添加商品",
          type: "warning",
        });
        return;
      }
      let addArr = this.shops.concat(this.drugs).concat(this.haocais);
      console.log(addArr);
      for (let i = 0; i < addArr.length; i++) {
        if (addArr[i].goodsCount == 0) {
          this.$message({
            message: `${addArr[i].goods.title}未输入采购数量`,
            type: "warning",
          });
          return;
        }
      }
      let parmars = {
        remarks: this.textarea,
        addProcureGoodsList: addArr,
      };
      console.log(parmars);
      addCaigou(parmars).then((res) => {
        console.log(res);
        if (res.code == 0) {
          this.$message({
            message: "已生成采购单",
            type: "success",
          });
          this.$router.go(-1);
        }
      });
    },
    //修改备注
    handleRemarkChange(type, index, scope) {
      // console.log(type,index)
      if (type == 1) {
        console.log("商品备注");
        this.shops[index].procureGoodsRemark = scope.row.procureGoodsRemark;
        // console.log(this.shops)
      } else if (type == 2) {
        console.log("药品备注");
        this.drugs[index].procureGoodsRemark = scope.row.procureGoodsRemark;
        // console.log(this.drugs)
      } else if (type == 3) {
        console.log("耗材备注");
        this.haocais[index].procureGoodsRemark =
          scope.row.procureGoodsRemark;
      }
    },
    //获取当天时间戳
    getDateData() {
      let y = new Date().getFullYear();
      let m =
        new Date().getMonth() + 1 < 10
          ? "0" + (new Date().getMonth() + 1)
          : new Date().getMonth() + 1;
      let d =
        new Date().getDate() < 10
          ? "0" + new Date().getDate()
          : new Date().getDate();
      let h =
        new Date().getHours() < 10
          ? "0" + new Date().getHours()
          : new Date().getHours();
      let mm =
        new Date().getMinutes() < 10
          ? "0" + new Date().getMinutes()
          : new Date().getMinutes();
      let s =
        new Date().getSeconds() < 10
          ? "0" + new Date().getSeconds()
          : new Date().getSeconds();
      let date = y + "-" + m + "-" + d;
      let dateStr = y + "-" + m + "-" + d + " " + h + ":" + mm + ":" + s;
      this.currentDate = date;
      this.dateStr = Date.parse(dateStr);
      console.log(this.currentDate, dateStr, this.dateStr);
    },
    //添加商品
    handleAddgoodsClick() {
      this.dialogAddShop_state = true;
      this.addGoodsType = false;
    },
    handleBackClick() {
      this.$confirm("是否退出当前页面？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          if (this.routerMsg == undefined) {
            this.$router.push({ path: "caigouList" });
            let storage = window.sessionStorage;
            storage.setItem("cgtabs", 1);
          } else {
            this.$router.go(-1);
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    //添加商品组件选择事件
    selectShop(row) {
      console.log(row);
      let shops = this.shops;
      let drugs = this.drugs;
      let haocais = this.haocais;
      let procure_goods = null;
      if (row.goodsType == 1) {
        console.log("选取药品11",row);
        if (drugs != undefined) {
          console.log(drugs);
          for (let i = 0; i < drugs.length; i++) {
            if (drugs[i].goods.goodsId == row.goodsItem.medical_id) {
              this.$message({
                message: "该药品已重复添加",
                type: "warning",
              });
              return;
            }
          }
          procure_goods = {
            goods: {
              goodsId: row.goodsItem.medical_id,
              title: row.goodsItem.title,
              skuId: "",
              skuValue: row.goodsItem.old_packinfo_info.sku_value,
              goodsType: 1,
              brand: row.goodsItem.brand_name,
              times: row.goodsItem.medical_ext_info.use_times,
							unit: row.wayItem,
										unitId:row.wayItem,
              barCode: row.goodsItem.barCode,
            },
            goodsCount: 1,
            procureGoodsRemark: "",
          };
          this.drugs.push(procure_goods);
          this.getAllData();
          console.log("添加药品列表", this.drugs);
          this.allCount =
            this.drugs.length + this.shops.length + this.haocais.length;
        }
      } else if (row.goodsType == 0) {
        console.log("选取商品", row);
        if (shops != undefined) {
          console.log(shops);
          for (let i = 0; i < shops.length; i++) {
            console.log(shops[i],'shops[i]选取商品');
            if (
              shops[i].goods.goodsId == row.goodsItem.goodsId &&
              shops[i].goods.skuValue == row.skuItem.skus_name &&
              shops[i].goods.unitId == row.wayItem.packing_way_id
            ) {
              this.$message({
                message: "该商品已重复添加",
                type: "warning",
              });
              return;
            }
          }
          procure_goods = {
            goods: {
              goodsId: row.goodsItem.goodsId,
              title: row.goodsItem.title,
              skuId: row.skuItem._id,
              skuValue: row.skuItem.skus_name,
              goodsType: 0,
              brand: row.goodsItem.brand_name,
              times: 1,
              barCode: row.goodsItem.barCode,
              unit: row.wayItem.packing_way_name,
              unitId: row.wayItem.packing_way_id,
            },
            goodsCount: 1,
            procureGoodsRemark: "",
          };
          this.shops.push(procure_goods);
          this.getAllData();
          console.log("添加商品列表", this.shops);
          this.allCount =
            this.drugs.length + this.shops.length + this.haocais.length;
        }
      } else if (row.goodsType == 7) {
        console.log("选取耗材", row);
        if (haocais != undefined) {
          console.log(haocais);
          for (let i = 0; i < haocais.length; i++) {
            if (haocais[i].goods.goodsId == row.goodsItem.consumablematerial_id) {
              this.$message({
                message: "该耗材已重复添加",
                type: "warning",
              });
              return;
            }
          }
          procure_goods = {
            goods: {
              goodsId: row.goodsItem.consumablematerial_id,
              title: row.goodsItem.title,
              skuId: "",
              skuValue: "",
              goodsType: 7,
              unit: row.goodsItem.packing_unit,
              unitId: row.goodsItem.packing_unit,
              brand: "",
              times: row.skuItem.use_times,
            },
            goodsCount: 1,
            procureGoodsRemark: "",
          };
          this.haocais.push(procure_goods);
          this.getAllData();
          console.log("添加耗材列表", this.haocais);
          this.allCount =
            this.drugs.length + this.shops.length + this.haocais.length;
        }
      }
    },
    //修改数值
    handleCountChange(type, row, index) {
      console.log(type, row, index);
      if (type == 1) {
        this.shops[index].goodsCount = row.goodsCount;
        this.getAllData();
        console.log(this.shops);
      } else if (type == 2) {
        this.drugs[index].goodsCount = row.goodsCount;
        this.getAllData();
        console.log(this.drugs);
      } else if (type == 3) {
        this.haocais[index].goodsCount = row.goodsCount;
        this.getAllData();
        console.log(this.haocais);
      }
    },
    handleShopClick() {
      //展开商品类
      this.showShop = !this.showShop;
    },
    //展开药品类
    handleDrugClick() {
      this.showDrug = !this.showDrug;
    },
    //展开耗材类
    handleHaocaiClick() {
      this.showHaocai = !this.showHaocai;
    },
    // 删除按钮
    handleDeleteClick(type, row, index) {
      this.$confirm("确认要删除这条信息吗?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          console.log(row);
          this.$message({
            message: "已删除",
            type: "success",
          });
          if (type == 1) {
            this.shops.splice(index, 1);
            this.getAllData();
          } else if (type == 2) {
            this.drugs.splice(index, 1);
            this.getAllData();
          } else if (type == 3) {
            this.haocais.splice(index, 1);
            this.getAllData();
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 获取合计
    getAllData() {
      let shops = this.shops;
      let drugs = this.drugs;
      let haocais = this.haocais;
      let shopCount = 0;
      let drugCount = 0;
      let haocaiCount = 0;
      if (shops.length > 0) {
        for (let i = 0; i < shops.length; i++) {
          shopCount = shopCount + shops[i].goodsCount;
        }
        this.shopCount = shopCount;
      }
      if (drugs.length > 0) {
        for (let j = 0; j < drugs.length; j++) {
          drugCount = drugCount + drugs[j].goodsCount;
        }
        this.drugCount = drugCount;
      }
      if (haocais.length > 0) {
        for (let k = 0; k < haocais.length; k++) {
          haocaiCount = haocaiCount + haocais[k].goodsCount;
         
        }
        this.haocaiCount = haocaiCount;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.page {
  height: 100%;

  // 重复头部
  .titleView {
    // width: 98%;
    padding: 20px 0;
    padding-left: 10px;
    margin: 0 auto;
    font-size: 14px;
    color: #2a2a2a;
    background: #fff;
    border-radius: 6px;
  }

  //重复标题
  .comH2 {
    line-height: 64px;
    font-size: 18px;
    display: flex;
    align-items: center;
  }

  .comH2 div {
    margin-left: 20px;
    margin-right: 6px;
    font-weight: bold;
  }

  .comH2 img {
    width: 16px;
    height: 16px;
    background: red;
  }

  .tableWarp {
    border-radius: 6px;
    background: #fff;
    padding: 20px 30px;

    .tableName {
      line-height: 46px;
      background: #f7f6f9;
      font-size: 18px;
      color: #2a2a2a;
      font-weight: bold;
      margin-bottom: 10px;
    }

    .allNum {
      font-size: 14px;
      background: #f5f5f5;
      height: 50px;
      display: flex;
      align-items: center;
      padding-left: 20px;

      div:nth-of-type(1) {
        margin-right: 20px;
      }
    }
  }
  .remarks {
    margin-top: 20px;
    display: flex;
    .labelRemark {
      font-size: 14px;
      margin-right: 10px;
    }
  }
  .fix_btn {
    position: fixed;
    bottom: 0;
    z-index: 6;
    left: 0;
    width: 100%;
    height: 72px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: flex-end;

    button {
      margin-right: 30px;
    }

    button:nth-of-type(5) {
      margin-right: 60px;
    }
  }
}
</style>
